/*
 * Ficha de producto Salty Dogs — comportamiento dinámico.
 *
 * Hace dos cosas:
 *   1. Cambia los números de la tabla de medidas cuando se elige otro talle.
 *   2. Muestra, oculta y actualiza el pill de % OFF según la variante.
 *
 * IMPORTANTE — por qué no usa los eventos del tema:
 * Kalles dispara "variant:updated" desde las cards de producto, pero NO desde
 * el selector de variantes de la ficha. Depender de ese evento hacía que la
 * tabla nunca se actualizara. Así que acá se resuelve la variante leyendo qué
 * opciones están tildadas en el selector y buscando la que coincide, lo cual
 * funciona igual con un talle solo o con talle + color, y sobrevive al
 * re-render que el tema hace del picker.
 */
(function () {
  'use strict';

  var DASH = '—';

  function parseJSONFrom(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  /* Qué opciones están elegidas ahora mismo en el selector de esta sección */
  function selectedOptions(scope) {
    var picker = scope.querySelector('hdt-variant-picker');
    if (!picker) return null;
    var fieldsets = picker.querySelectorAll('fieldset');
    if (!fieldsets.length) return null;

    var values = [];
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var checked = fs.querySelector('input:checked');
      if (checked && checked.value) {
        values.push(checked.value);
        continue;
      }
      /* Modo dropdown: el valor vive en un input oculto */
      var hidden = fs.querySelector('input[type="hidden"][is-value]');
      if (hidden && hidden.value) {
        values.push(hidden.value);
        continue;
      }
      var selected = fs.querySelector('[aria-selected="true"]');
      if (selected) {
        values.push(selected.textContent.trim());
        continue;
      }
      return null;
    }
    return values;
  }

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (String(a[i]).trim() !== String(b[i]).trim()) return false;
    }
    return true;
  }

  /* Busca la fila por opciones elegidas; si no, por id de variante */
  function findRow(rows, options, variantId) {
    if (!rows || !rows.length) return null;
    var i;
    if (options) {
      for (i = 0; i < rows.length; i++) {
        if (sameOptions(rows[i].o, options)) return rows[i];
      }
    }
    if (variantId) {
      for (i = 0; i < rows.length; i++) {
        if (String(rows[i].id) === String(variantId)) return rows[i];
      }
    }
    return null;
  }

  function flash(el) {
    el.classList.remove('is-swapping');
    void el.offsetWidth;
    el.classList.add('is-swapping');
  }

  function updateMedidas(scope, options, variantId) {
    var blocks = scope.querySelectorAll('[data-sd-medidas-block]');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var rows = parseJSONFrom(block.querySelector('[data-sd-medidas-data]'));
      var row = findRow(rows, options, variantId);
      var unit = block.getAttribute('data-sd-unit') || '';

      /* Variante sin medidas cargadas: se esconde el bloque en vez de
         mostrar una tabla llena de guiones. */
      if (!row || !row.m) {
        block.hidden = true;
        continue;
      }
      block.hidden = false;

      var cells = block.querySelectorAll('[data-sd-medida]');
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        var value = row.m[cell.getAttribute('data-sd-medida')];
        var text =
          value === undefined || value === null || value === ''
            ? DASH
            : unit
              ? value + ' ' + unit
              : String(value);
        if (cell.textContent.trim() !== text) {
          cell.textContent = text;
          flash(cell);
        }
      }
    }
  }

  function updatePill(scope, options, variantId) {
    var pills = scope.querySelectorAll('[data-sd-pill]');
    for (var p = 0; p < pills.length; p++) {
      var pill = pills[p];
      var holder = pill.parentNode;
      var rows = parseJSONFrom(holder.querySelector('[data-sd-pill-data]'));
      var row = findRow(rows, options, variantId);
      var pct = row ? Number(row.pct) : 0;

      if (!pct) {
        pill.hidden = true;
        continue;
      }
      var tpl = pill.getAttribute('data-sd-pill-tpl') || '[percent]% OFF';
      var text = tpl.replace('[percent]', pct);
      if (pill.textContent.trim() !== text) {
        pill.textContent = text;
        flash(pill);
      }
      pill.hidden = false;
    }
  }

  function refresh(scope, variantId) {
    if (!scope) return;
    var options = selectedOptions(scope);
    if (!options && !variantId) return;
    updateMedidas(scope, options, variantId);
    updatePill(scope, options, variantId);
  }

  function scopeOf(el) {
    if (!el || !el.closest) return null;
    return el.closest('[id^="shopify-section-"]') || document;
  }

  /* Un cambio de talle re-renderiza el picker, así que escuchamos en el
     documento y repetimos un instante después, por si el tema todavía no
     terminó de marcar la opción nueva. */
  function onPick(event) {
    var picker = event.target && event.target.closest
      ? event.target.closest('hdt-variant-picker')
      : null;
    if (!picker) return;
    var scope = scopeOf(picker);
    refresh(scope);
    setTimeout(function () { refresh(scope); }, 120);
    setTimeout(function () { refresh(scope); }, 450);
    setTimeout(function () { refresh(scope); }, 900);
  }

  document.addEventListener('change', onPick, true);
  document.addEventListener('click', onPick, true);

  /* Por si alguna versión del tema sí emite el evento */
  document.addEventListener('variant:updated', function (event) {
    var variant = event.detail && event.detail.variant;
    refresh(scopeOf(event.target), variant && variant.id);
  });

  /* ---------------------------------------------------------------------
   * Indicadores del carrusel de la galería en mobile.
   * El tema no dibuja puntos en este layout, así que los generamos y los
   * sincronizamos con su evento "slideChanged" (trae detail.currentPage).
   * ------------------------------------------------------------------ */
  function buildDots() {
    if (window.matchMedia('(min-width: 1150px)').matches) return;

    var main = document.querySelector('.hdt-product-media__main');
    if (!main) return;
    var slider = main.querySelector('.hdt-slider');
    if (!slider) return;

    var slides = main.querySelectorAll('.hdt-slider__slide:not([hidden])');
    if (slides.length < 2) return;

    /* Si la tira de miniaturas está a la vista, los puntos sobran */
    var thumb = main.parentNode.querySelector('.hdt-product-media__thumb');
    if (thumb && thumb.offsetParent !== null) {
      var old = main.parentNode.querySelector('.sd-dots');
      if (old) old.parentNode.removeChild(old);
      return;
    }

    var existing = main.parentNode.querySelector('.sd-dots');
    if (existing) existing.parentNode.removeChild(existing);

    var dots = document.createElement('div');
    dots.className = 'sd-dots';
    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'sd-dots__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(dot);
    }
    main.parentNode.insertBefore(dots, main.nextSibling);

    function mark(page) {
      var all = dots.querySelectorAll('.sd-dots__dot');
      for (var j = 0; j < all.length; j++) {
        all[j].classList.toggle('is-active', j === page - 1);
      }
    }
    slider.addEventListener('slideChanged', function (e) {
      if (e.detail && e.detail.currentPage) mark(e.detail.currentPage);
    });
  }

  /* Estado inicial: cubre el caso de entrar con ?variant= en la URL */
  function init() {
    var pickers = document.querySelectorAll('hdt-variant-picker');
    for (var i = 0; i < pickers.length; i++) refresh(scopeOf(pickers[i]));
    buildDots();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.__sdDotsT);
    window.__sdDotsT = setTimeout(buildDots, 250);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
